import { render } from "./ProjectSingle.vue?vue&type=template&id=28d477de&scoped=true"
import script from "./ProjectSingle.vue?vue&type=script&lang=js"
export * from "./ProjectSingle.vue?vue&type=script&lang=js"

import "./ProjectSingle.vue?vue&type=style&index=0&id=28d477de&lang=css&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d477de"]])

export default __exports__